import { useWorkspace } from '../app/workspace';

export function StatusNotice() {
  const { notice, error, online, clearNotice } = useWorkspace();
  const message = error?.message ?? notice;
  if (!message && online) return null;
  return (
    <div className={`status-notice ${error ? 'status-notice--error' : !online ? 'status-notice--offline' : ''}`} role={error ? 'alert' : 'status'} aria-live={error ? 'assertive' : 'polite'}>
      <div>
        <strong>{error ? '저장하지 못했어요' : !online ? '오프라인' : '기록됨'}</strong>
        <span>{message ?? '연결이 돌아오면 다시 저장할 수 있어요.'}</span>
        {error?.requestId && error.requestId !== 'network' ? <small>요청 번호 {error.requestId}</small> : null}
      </div>
      <button type="button" className="icon-button" onClick={clearNotice} aria-label="알림 닫기">×</button>
    </div>
  );
}
